import { readFile } from "../../../utilities/readFile";
import * as XLSX from "xlsx";
import { useCallback, useState } from "react";
import async from "async";
import { ProgressBar } from "react-bootstrap";
import useAxios from "../../../services/useAxios";
import useWindowSize from "../../../hooks/useWindowSize";

export default function UploadExcelLine() {
  let regNumber = /^\d+$/;
  let { width, height } = useWindowSize();
  const [excelData, setExcelData] = useState({
    errorList: [],
    completeCount: 0,
    totalCount: 0,
  });
  const translate = {
    id: 1,
    title: 2,
    description: 3,
    main_cat: 5,
    parent_line_id: 6,
    img_name: 4,
  };
  const { execute: uploadExcel } = useAxios("supplier/add_suppliersLine ");
  const errorReason = (status) => {
    let reason = "";
    switch (status) {
      case -100:
        reason = "نوع یا الزامی بودن ستونهای اکسل رعایت نشده است.";
        break;
      case -2:
        reason = "مشکلی در ثبت عکس پیش آمده است.";
        break;
      case -3:
        reason = "مشکلی در ثبت پیش آمده است.";
        break;
    }
    return reason;
  };
  const dataHandler = (object) => {
    setExcelData((prev) => {
      return { ...prev, ...object };
    });
  };
  const errorHandler = (object) => {
    setExcelData((prev) => {
      return { ...prev, errorList: [...prev.errorList, object] };
    });
  };
  const AddOne = () => {
    setExcelData((prev) => {
      return { ...prev, completeCount: prev.completeCount + 1 };
    });
  };
  const resetData = () => {
    setExcelData({
      errorList: [],
      completeCount: 0,
      totalCount: 0,
    });
  };
  const finalQueue = async.queue((task, callback) => {
    // console.log("task", task);
    uploadExcel(task).then((res) => {
      if (res.status == 1) {
        AddOne();
        callback();
      } else {
        errorHandler({ ...task, status: res.status });
        callback();
      }
    });
  }, 10);
  // TODO: check required values
  const requestFunc = useCallback(
    (data) => {
      dataHandler({ totalCount: data.length });
      let temp = data.map((value) => {
        return {
          id: value[1],
          title: value[2] != undefined ? value[2] : "",
          description: value[3] != undefined ? value[3] : "",
          main_cat: value[5],
          status: 0,
          parent_line_id: value[6],
          line_status: 0,
          img_name: value[4] != undefined ? value[4] : "",
        };
      });
      finalQueue.push(temp);
      console.log(temp);
      // console.log(data.filter((val) => console.log(val[2])));
    },
    [finalQueue]
  );
  const FileHandler = useCallback(
    async (e) => {
      resetData();
      let files = e.target.files;

      for (let i = 0; i < files.length; i++) {
        let file = await readFile(files);
        let data = XLSX.read(file, {
          type: "binary",
          raw: true,
        });
        for (let sheetName of data.SheetNames) {
          let res = XLSX.utils.sheet_to_json(data.Sheets[sheetName], {
            header: 1,
          });
          let x = res.filter((val, ind) => {
            if (
              ind != 0 &&
              val[2] != "" &&
              regNumber.test(val[1]) &&
              regNumber.test(val[5]) &&
              regNumber.test(val[6])
            )
              return val;
            else if (ind != 0)
              errorHandler({
                id: val[1],
                title: val[2] != undefined ? val[2] : "",
                description: val[3] != undefined ? val[3] : "",
                main_cat: val[5],
                status: 0,
                parent_line_id: val[6],
                line_status: 0,
                img_name: val[4] != undefined ? val[4] : "",
                status: -100,
              });
          });
          requestFunc(x);
        }
      }
    },
    [requestFunc]
  );
  return (
    <div>
      <p className="title-h3-m mt-3 text-center">آپلود لاین و ساب لاین</p>
      <div
        className="text-center mb-4 mt-3 border rounded  py-4  mx-auto border-success shadow d-flex flex-column "
        style={{
          width: width > 800 ? "50%" : "90%",
          padding: width > 800 ? "0 20px" : "0 10px",
        }}
      >
        <p className="my-2 txt-t3-m">لطفا فایل مورد نظر را آپلود کنید.</p>
        <input
          className="mx-auto border rounded mb-3"
          type="file"
          style={{ overflow: "hidden" }}
          onChange={(e) => {
            FileHandler(e);
          }}
        />
        <ProgressBar
          className="mb-2"
          now={excelData.completeCount}
          max={excelData.totalCount}
          variant="success"
        />
        {/* <input
          id="upload-line"
          type="range"
          min={0}
          // max={state.recordsCount}
          max={excelData.totalCount}
          step={1}
          className="range-input mt-3 w-50 mx-auto"
          value={excelData.completeCount}
          disabled
        /> */}
        {excelData.totalCount}/{excelData.completeCount}
      </div>
      <div className="ms-3 txt-t2-m">
        {" "}
        <ul>
          {excelData.errorList.map((value) => {
            return (
              <li>
                {value.title}&nbsp; {"=>"} &nbsp;
                <span className="text-danger">{errorReason(value.status)}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
